module.exports = __webpack_public_path__ + "img/yishiyong.251241fc.png";